export default __webpack_public_path__ + "static/media/es.c812b0e0.svg";